module.exports = {
  myPets: 'Mes animaux',
  myProfile: 'Mon profil',
  logout: 'Déconnexion',
};
